import React, { useEffect, useState } from 'react'
import Navbar from "../component/NavBar"
import { Link } from 'react-router-dom';
import { getAllProduct } from "../Api/services/ProductsService"
import Loader from "../component/common/Loader"
import Footer from '../component/Footer';

const ProductList = () => {
    const [product, setProduct] = useState([]);
    const [loading, setLoading] = useState(false);

    const getAllProductS = async () => {
        setLoading(true);
        try {
            const res = await getAllProduct();
            console.log(res.data)
            setProduct(res.data)
        } catch (error) {
            console.log(error.message)
        }
        setLoading(false);
    }
    useEffect(() => {
        getAllProductS();
        // Scroll to top with smooth behavior
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [])
    return (<>
        <Navbar />
        {loading ? <Loader /> : (
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 ">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {product.map((item, index) => (
                        <div key={index} className="h-full">
                            <Link to={`/product/${item._id}`} className="block h-full">
                                <div className="bg-white shadow-md h-full overflow-hidden">
                                    <img
                                        src={item.images[0]}
                                        alt={item.title}
                                        className="w-full h-96 object-cover"
                                    />
                                    <div className="p-4 tracking-widest font-semibold font-cormorant">
                                        <h2 className="text-md font-bold text-gray-800 mb-2">
                                            {item.title}
                                        </h2>
                                        <p className="text-green-500">{item?.discount ? `Get ${item?.discount}% Off` : null}</p>
                                        <p className="text-gray-600">Rs.{item?.discountedPrice}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        )}
        <Footer />
    </>)
}

export default ProductList